import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({
  providedIn: 'root',
})
export class EnvCdssIntService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: true,
      _enableRefreshToken: false,
      isMagellan: '0',
      _env: 'cdss-int',
      _apiUrl: 'https://int3-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://int3-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer:
        'https://cdssintadb2c.b2clogin.com/a0acf126-bad1-4eb7-8522-16aa916950a0/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint:
        'https://cdssintadb2c.b2clogin.com/cdssintadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl:
        'https://cdssintadb2c.b2clogin.com/cdssintadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '3f23e6a8-88f4-43cb-9e3b-545438e0ce06',
      _scope:
        'openid profile https://cdssintadb2c.onmicrosoft.com/api/cdss.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl:
        'https://cdssintadb2c.b2clogin.com/cdssintadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://int3-login.p-cis.com/',
      _signInURL:
        'https://cdssintadb2c.b2clogin.com/cdssintadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO:
        'https://cdssintadb2c.b2clogin.com/cdssintadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl:
        'https://cdssintadb2c.b2clogin.com/cdssintadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://cdssintadb2c.b2clogin.com/cdssintadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _oktaClientId: '0oagmwdy51QBeEDmm4h7',
      _oktaIssuer: 'https://login.5.cares.cwds.ca.gov/oauth2/ausgmw9ku9Wu9IK2J4h7',
      _oktaRedirectUri: 'https://int3-login.p-cis.com/auth/okta/callback',
      _authEndpoint:
        'https://cdssintadb2c.b2clogin.com/cdssintadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://cdssintadb2c.b2clogin.com/cdssintadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9aaf',
      _intercomAppId: 'bqgvwybf'

    };
  }
}
